const PREFIX = "cj-vid-";

/** @param {string} id */
export function getSavedVideoTime(id) {
  try {
    return parseFloat(localStorage.getItem(`${PREFIX}${id}`)) || 0;
  } catch {
    return 0;
  }
}

/** @param {string} id @param {number} time */
export function saveVideoTime(id, time) {
  try {
    localStorage.setItem(`${PREFIX}${id}`, String(time));
  } catch {
    /* ignore */
  }
}

/** @param {number} seconds */
export function formatVideoTime(seconds) {
  const total = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(total / 60);
  const secs = total % 60;
  return `${minutes}:${String(secs).padStart(2, "0")}`;
}
